import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Maps.scss'

const Maps = ({ title, maps }) => {
  return (
    <div className="my-5 container map-component">
      <h3 className='title fw-bold'>{title}</h3>
      
      <Row className='maps'>
        {maps.map((mapContent) => {
          if (mapContent.visible) {
            return ( 
              <React.Fragment key={mapContent.id}>
                {mapContent.mapContentText ? (  
                  <Col lg={12} xs={12}
                    key={mapContent.id}
                    id={`map-container-${mapContent.id}`}
                    className="w-100 shadow-sm rounded p-2 mb-2 d-flex flex-column"
                  >
                    <Row className='m-0'>
                      <Col lg={6} xs={12}
                        className='frame-section' 
                        dangerouslySetInnerHTML={{ __html: mapContent.code }} 
                        style={{ height: '490px'}} 
                      />
                      <Col lg={6} xs={12} className='content-section'>
                        <div className='d-flex align-items-center mb-2'>
                          <FontAwesomeIcon icon={["fas", "fa-location-dot"]} color={'red'} size='xl' className='me-3'/>
                          <h4 className='m-0'>{mapContent.title}</h4>
                        </div>
                        <div>
                          <h5 className='fw-bold'>Dirección:</h5>
                          <h6>{mapContent.mapContentText.address}</h6>
                        </div>
                        <div>
                          <h5 className='fw-bold'>Contacto:</h5>
                          <h6>{mapContent.mapContentText.contact}</h6>
                        </div>
                        <div>
                          <h5 className='fw-bold'>Horario de atención:</h5>
                          <h6>{mapContent.mapContentText.openingHours}</h6>
                        </div>
                        <div className='image-section'>
                          <img src={mapContent.mapContentText.image?.url} className='rounded-lg' alt='MapContent'/>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <Col lg={6} xs={12}
                    key={mapContent.id}
                    id={`map-container-${mapContent.id}`}
                    className="shadow-sm rounded p-2 mb-2 d-flex flex-column"
                  >
                    <div
                      className='frame-section mb-2' 
                      dangerouslySetInnerHTML={{ __html: mapContent.code }} 
                      style={{ height: '490px' }} 
                    />
                    <div className='d-flex align-items-center mb-2'>
                      <FontAwesomeIcon icon={["fas", "fa-location-dot"]} color={'red'} size='xl' className='ms-2 me-3'/>
                      <h4 className='m-0'>{mapContent.title}</h4>
                    </div>
                  </Col>
                )}
              </React.Fragment>
            )
          } else return null
        })}
      </Row>
    </div>
  )
}

export default Maps

Maps.propTypes = {
  title: PropTypes.string,
  maps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      mapContentText: PropTypes.shape({
        address: PropTypes.string.isRequired,
        contact: PropTypes.string.isRequired,
        openingHours: PropTypes.string.isRequired,
        image: PropTypes.shape({
          url: PropTypes.string.isRequired
        })
      })
    })
  ).isRequired
}
